import * as React from "react";

import { DatePicker, Form, Radio } from "antd";

const SignupGenderAge = ({ genderAge, setGenderAge }) => {
	/**
	 * 체크 박스 추가
	 * @param checkedValues
	 */
	const onChangeCheckValue = (e) => {
		setGenderAge({
			...genderAge,
			gender: e.target.value,
		});
	};

	const onChangeDate = (date, dateString) => {
		setGenderAge({
			...genderAge,
			age: date,
		});
	};

	return (
		<>
			<p className={`signup-sub-title signup-border`}>
				성별/생년월일을 입력해주세요.
			</p>

			<Form layout={`vertical`} className={`signup-userInfo-div`}>
				<Form.Item
					label={"성별"}
					labelAlign="left"
					colon={false}
					fieldKey={`gender`}
					key={`gender`}
				>
					<Radio.Group
						onChange={onChangeCheckValue}
						value={genderAge.gender}
						className={`route-group`}
					>
						<Radio value={1}>여성</Radio>
						<Radio value={2}>남성</Radio>
					</Radio.Group>
				</Form.Item>

				<Form.Item
					label={"생년월일"}
					labelAlign="left"
					colon={false}
					fieldKey={`age`}
					key={`age`}
				>
					<DatePicker
						format={"YYYY년 MM월 DD일"}
						value={genderAge.age}
						onChange={onChangeDate}
						allowClear={false}
						popupClassName={"gender-age-pop-up"}
						// placement={"bottomRight"}
					/>
				</Form.Item>
			</Form>
		</>
	);
};
export default SignupGenderAge;
